import { render, staticRenderFns } from "./RemoveBadgeDialog.vue?vue&type=template&id=3f67488c&scoped=true"
import script from "./RemoveBadgeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveBadgeDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RemoveBadgeDialog.vue?vue&type=style&index=0&id=3f67488c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67488c",
  null
  
)

export default component.exports